<template>
  <div class="col-xs-10 col-sm-10 grid_div" id="grid_right_div">
    <!--<div id="flushBtn"></div>-->
    <div id="contentDiv">
      <div class="head_title">
        <div class="head_title_font">课题征集管理&gt;</div>
      </div>
      <div class="body_content">
        <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content query-modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                <h4 class="modal-title" id="myModalLabel">{{optionFlag=="add"?'新增':'修改'}}课题</h4>
              </div>
              <div class="modal-body modal_work_trainingManage">
                <div>
                  <label>标题：</label>
                  <input type="text" v-validate="'required|maxL:100'" data-vv-scope="collection" data-vv-as="标题" name="title"  placeholder="输入标题" class="form-control lesson_name" v-model="collection.title"/>
                  <span class="spanRed">*</span>
                  <span class="validateTip">{{ errors.first('collection.title') }}</span>

                  <label>截止时间：</label>
                  <input type="text" class="form-control modelInput" v-validate="'required|maxL:80'" data-vv-scope="collection" data-vv-as="截止时间"  name="deadLine"  placeholder="输入截止时间" id="deadLine" v-model="collection.deadLine" readonly>
                  <span class="spanRed">*</span>
                  <span class="validateTip">{{ errors.first('collection.deadLine') }}</span>

                  <label>描述：</label>
                  <textarea class="form-control description-textarea" v-validate="'maxL:200'" data-vv-scope="collection" data-vv-as="描述" placeholder="描述" rows="10" name="des" v-model="collection.des" style="resize: none"></textarea>
                  <span class="spanRed"></span>
                  <span class="validateTip">{{ errors.first('collection.des') }}</span>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-default" @click="saveData()">确定</button>
                <button type="button" class="btn btn-default" data-dismiss="modal" @click="">取消</button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal fade" id="myViewModal" tabindex="-1" role="dialog" aria-labelledby="myViewModalLabel" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content query-modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                <h4 class="modal-title" id="myModalLabel">课题详情</h4>
              </div>
              <div class="modal-body query-modal-lesson">
                <div class="form-group">
                  <label class="unit_content_label_name">标题：</label>{{collection.title}}
                </div>
                <div class="form-group">
                  <label class="unit_content_label_name">描述：</label>{{collection.des}}
                </div>
                <div class="form-group">
                  <label class="unit_content_label_name">截止时间：</label>{{collection.deadLine}}
                </div>
                <div class="form-group">
                  <label class="unit_content_label_name">状态：</label>
                  <span v-if="collection.status == '0'">未发布</span>
                  <span v-if="collection.status == '1'">已发布</span>
                </div>
{{collection}}
              </div>
              <div class="modal-footer">
<!--                <button type="button" class="btn btn-default okBtn" @click="addLesson()">确定</button>-->
<!--                <button type="button" class="btn btn-default okBtn" data-dismiss="modal" @click="">取消</button>-->
              </div>
            </div>
          </div>
        </div>
        <div class="classList_div">
<!--          <div class="searcharea">-->
<!--            <label style="margin: 10px 0 10px 5px;">时间筛选:</label>-->
<!--            <input id="startDate" data-vv-as="开始日期" class="form-control new_date" size="16" type="text" name="startDate" readonly v-model="searchParams.startDate"/>-->
<!--            <span class="spanRed"></span>-->
<!--            ——-->
<!--            <input id="endDate" data-vv-as="结束日期" class="form-control new_date" size="16" type="text" name="endDate" readonly v-model="searchParams.endDate"/>-->
<!--            <input class="form-control" placeholder="请输入班级名称"  v-model="searchParams.name"/>-->
<!--            <button type="button" class="btn btn-default btn_option" @click="searchParams.page==1;searchParams.rows=10;pageClick()">查询</button>-->
<!--            <button type="button" class="btn btn-default" @click="refresh()">重置</button>-->
<!--          </div>-->
          <div class="exportClass">
            <button type="button" class="btn btn_option"
                    @click="optionFlag='add';add()" style="width: 100px;">新建</button>
          </div>
          <table class="table table-striped table-bordered">
            <thead>
            <tr>
              <th width="20%">标题</th>
              <th width="20%">描述</th>
              <th width="20%">截止时间</th>
              <th width="20%">状态</th>
              <th width="15%">操作</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(collectionOne, index) in dataList" :key="index">
              <td width="20%">{{collectionOne.title}}</td>
              <td width="20%">{{collectionOne.des}}</td>
              <td width="20%">{{collectionOne.deadLine}}</td>
              <td width="20%">
                <span v-if="collectionOne.status == '0'">未发布</span>
                <span v-if="collectionOne.status == '1'">已发布</span>
              </td>
              <td width="15%"><!--:class="{show_edit_pic: collectionOne.checkStatus == 0}"-->
                <template v-if="collectionOne.status == '0'">
                  <a href="#" @click="optionFlag='edit';update(collectionOne)">修改</a>
                  <a href="#" @click="deleteData(collectionOne.id)">删除</a>
                  <a href="#" @click="updateStatus(collectionOne)">发布</a>
                </template>
                <a href="#" @click="getData(collectionOne)">查看</a>
              </td>
            </tr>
            </tbody>
          </table>
          <!--分页-->
          <page-view v-bind="searchParams"></page-view>
        </div>

      </div>
    </div>
  </div>
<!--  <ResearchFeedback1 :colId="colId"></ResearchFeedback1>-->
</template>

<script>
import {schoolAxios} from '../main';
import {getContentSize} from './mainView';
import ResearchFeedback1 from './researchFeedback1'
import pageView from "./pageView";

export default {
  name: "researchCollection",
  components:{pageView},
  data() {
    return {
      // colId: '',
      dataList: [],
      searchParams: {
        title:'',
        all: 0,
        rows: 10,
        page:1
      },
      optionFlag:"",
      collection: {
        id: '',
        title: '',
        des: '',
        crator: '',
        status: '0',
        deadLine: '',
      }
    }
  },
  mounted: function () {
    let this_ = this;
    this.$nextTick(function () {
      getContentSize();
      this_.initData();
      this_.dateDefault();
      this_.searchParams.page = 1;
      this_.searchParams.pageCallback = this_.initData;
      // this_.getClassCountsByStatus();
    });
  },
  methods: {
    dateDefault(){
      let this_ = this;
      let date, nowDate;
      date = new Date();
      nowDate = date.getFullYear() + "-";
      nowDate += (date.getMonth() + 1) + "-";
      nowDate += date.getDate() + " ";
      this_.timeDate = nowDate;
      $('#deadLine').datetimepicker({
        minView: "month",//选择日期后，不会再跳转去选择时分秒
        language: 'zh-CN',
        format: 'yyyy-mm-dd',
        //startDate: this_.timeDate,
        weekStart: 0,
        todayBtn: true,
        clearBtn: true,
        autoclose: true,//选择一个日期后是否立即关闭此选择框
        todayHighlight: true,//高亮当前日期
        startView: 2,// 日期时间选择器打开之后首先显示的视图，默认值为：2，0:hour,1:day,2:mouth,3:year,4:decade
        forceParse: 0,
        showMeridian: 1,
      }).on('hide', function (ev) {
        let value = $("#deadLine").val();
        this_.collection.deadLine = value;

        ev.preventDefault();
        ev.stopPropagation();
      });
    },
    initData(pageParams){
      let this_ = this;
      if(pageParams)
        Object.assign(this_.searchParams, pageParams);

      let _searchParams = {};
      Object.assign(_searchParams, this_.searchParams);
      delete _searchParams.pageCallback;//提交前删除回调
      console.log('--------------_searchParams',_searchParams)
      schoolAxios({
        method: 'get',
        url: 'researchCollection/findPage',
        params:_searchParams
      }).then(function (response) {
        console.info(response);
        let data = response.data;
        if (data.success) {
          this_.dataList = data.list;
          this_.searchParams.all = data.totalPage;
          this_.searchParams.page = 1;
        }
      });
    },
    pageClick(){
      let this_=this;
      //console.log('现在是'+this.cur+'页');
      this_.initClassData();
    },
    pageSkip(){
      var maxPage = this.searchParams.all;
      var skipPage = Number(document.getElementsByClassName("jumppage")[0].value);
      //console.log(typeof skipPage);
      if(!skipPage){
        alert("请输入跳转页码");
        return;
      }else if(skipPage<1 || skipPage>maxPage){
        alert("您输入的页码超过页数范围了！");
        return;
      }else{
        this.searchParams.page=skipPage;
        // this.btnClick(skipPage);
        this.pageClick();
      }
    },
    updateStatus(data){
      let this_=this;
      this_.collection = {
        id: data.id,
        title: data.title,
        des: data.des,
        crator: data.crator,
        status: '1',
        deadLine:data.deadLine,
      };
      ("确定发布吗？").showConfirm(function () {
        schoolAxios({
          method: 'put',
          url:'researchCollection/edit',
          data: this_.collection
        // {
        //     "id":id,
        //     "status":'1'
        //   }
        }).then(function (response) {
          let data = response.data;
          if(data.success){
            this_.initData();
          }
        });
      })
    },
    update(collectionOne){
      let this_ = this;

      this_.collection = {
        id: collectionOne.id,
        title: collectionOne.title,
        des: collectionOne.des,
        crator: collectionOne.crator,
        status: collectionOne.status,
        deadLine:collectionOne.deadLine,
      };

      $("#myModal").modal('show');
      setTimeout(function () {
        this_.errors.clear('collection');
      });
    },
    updateData(){
      let this_=this;
      console.log('----------------updateData:',this_.collection)
      this_.$validator.validateAll('collection').then(result => {
        if (result) {
          schoolAxios({
            method: 'put',
            url: 'researchCollection/edit',
            params: this_.collection
            // {
            //     "id":collectionOne.id,
            //     "title":collectionOne.title,
            //     "des":collectionOne.des,
            //     "deadLine":collectionOne.deadLine,
            //   }
          }).then(function (response) {
            let data = response.data;
            if (data.success) {
              $("#myModal").modal("hide");
              setTimeout(function () {
                this_.errors.clear('collection');
              });
              this_.initData();
            }
          });
        }
      })
    },
    deleteData(id){
      let this_ = this;
      //执行删除
      "确定是否删除".showConfirm(function () {
        schoolAxios({
          method: 'delete',
          url: 'researchCollection/delete/'+id,
          params: {}
        }).then(function (response) {
          console.info(response);
          let data = response.data;
          if(data.success){
            this_.initData();
          }
        });
      })
    },
    add(){
      let this_=this;
      // this_.errors.clear('trainingPeople');
      Object.keys(this_.collection).forEach(i=>{
        this_.collection[i] = ''
      })
      this_.collection.status = '0'
      $("#myModal").modal("show");
      setTimeout(function () {
        this_.errors.clear('collection');
      });
    },
    addData(){
      let this_ = this;
      console.log('------------this_.collection:',this_.collection)
      this_.$validator.validateAll('collection').then(result => {
        if (result) {
          schoolAxios({
            method: 'post',
            url: 'researchCollection/add',
            data: this_.collection
          }).then(function (resp) {
            let data = resp.data;
            if(data.success){
              $("#myModal").modal("hide");
              // "保存成功".showMessage();
              setTimeout(function () {
                this_.errors.clear('collection');
              });
              this_.initData();
            }else{
              (data.message||"保存失败").showMessage();
            }
          })
        }
      });
    },
    saveData(){
      let this_ = this;
      if(this_.optionFlag == 'add'){
        this_.addData();
      }else {
        this_.updateData();
      }
    },
    getData(collectionOne){
      let this_ = this;
      // this_.collection = {
      //   id: collectionOne.id,
      //   title: collectionOne.title,
      //   des: collectionOne.des,
      //   crator: collectionOne.crator,
      //   status: collectionOne.status,
      //   deadLine:collectionOne.deadLine,
      // };
      // $("#myViewModal").modal('show');
      this_.$store.set("colId", collectionOne.id);
      this_.$store.set("colTitle", collectionOne.title);
      //路由跳转
      this_.$router.push({
        name: 'ResearchFeedback1',/*this_.classStatus==0?'OpenClassMessage':'ClassBasisAfter',
            params: {
              clazzId: this_.clazzId,
              publishStatus: this_.publishStatus,
              classStatus: this_.classStatus
            }*/
      });
    },
  },
  computed: {
    indexs(){
      var left = 1;
      var right = this.searchParams.all;
      var arr = [];
      if(this.searchParams.all>=7){
        if(this.searchParams.page>4 && this.searchParams.page<this.searchParams.all-3){
          left = this.searchParams.page-3;
          right = this.searchParams.page+3;
        }else if(this.searchParams.page<=4){
          left=1;
          right=7;
        }else{
          left=this.searchParams.all-6;
          right=this.searchParams.all;
        }
      }
      while(left<=right){
        arr.push(left);
        left++;
      }
      return arr;
    }
  }
}
</script>

<style scoped>
@import '../assets/css/plugins.css';
@import "../assets/css/publicStyle.css";

.situation_all_div {
  position: relative;
  top: 2%;
  width: 100%;
  height: 10%;
}
.situation_one_div {
  float: left;
  width: 14%;
  height: 100%;
  color: white;
  font-size: 18px;
  line-height: 75px;
  margin: 0px 1% 1% 1%;
  padding-left: 10px;
  position: relative;
}
.situation_one_div:nth-child(1) {
  background-color: #ff4d42;
}
/*已发布*/
.situation_one_div:nth-child(2) {
  background-color: #FF5A58;
}
.situation_one_div:nth-child(3) {
  background-color: #fb6b51;
}
.situation_one_div:nth-child(4) {
  background-color: #f78a42;
}
.situation_one_div:nth-child(5) {
  background-color: #f79851;
}
.situation_one_div:nth-child(6) {
  background-color: #eba600;
}
.situation_one_div span {
  font-size: 45px;
  font-weight: bold;
}
.situation_one_div div {
  float: right;
  width: 25%;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  opacity: 0.6;
}
.situation_one_img {
  background-color: #d6483f;
  text-align: center;
}
.situation_two_img {
  background-color: #d5604b;
  text-align: center;
}
.situation_three_img {
  background-color: #d0793f;
  text-align: center;
}
.situation_four_img {
  background-color: #d0844b;
  text-align: center;
}
.situation_five_img {
  background-color: #c68f0a;
  text-align: center;
}
.situation_six_img {
  background-color: #D6594E;
  text-align: center;
}

/*.situation_one_div div img {
  margin-left: 18%;
}*/


.classList_div {
  position: relative;
  /*top: 2%;*/
  width: 100%;
  /*height: 86%;*/
  overflow: auto;
}

table tr{
  text-align: center;
}
table th {
  background: #cccccc;
  text-align: center;
}
.table-striped {
  /*background-color: #D7D7D7;*/
}
/*.table tbody{
  display: block;
  height: 640px;
  overflow: auto;
}*/



.action_pic {
  margin-left: 20%;
}
.edit_pic {
  width: 29px;
  height: 22px;
  background-image: url("../assets/img/right/clazz/edit_disabled.png");
  background-size: 100% 100%;
  float: left;
}
.delete_pic {
  width: 29px;
  height: 22px;
  background-image: url("../assets/img/right/clazz/delete_disabled.png");
  background-size: 100% 100%;
  float: left;
}
.graduate_pic {
  width: 29px;
  height: 22px;
  background-image: url("../assets/img/right/clazz/graduate.png");
  background-size: 100% 100%;
  display: inline-block;
  cursor: pointer;
}
.details_pic {
  width: 29px;
  height: 22px;
  background-image: url("../assets/img/right/clazz/details_disabled.png");
  background-size: 100% 100%;
  float: left;
}
.show_edit_pic {
  background-image: url("../assets/img/right/clazz/edit_mouseOver.png");
  cursor: pointer;
}
.show_delete_pic {
  background-image: url("../assets/img/right/clazz/delete_mouseOver.png");
  cursor: pointer;
}
.show_details_pic {
  background-image: url("../assets/img/right/clazz/details_mouseOver.png");
  cursor: pointer;
}


.edit_pic,.delete_pic,.details_pic {
  margin: 0 0 0 12%;
}
.export_content {
  position: relative;
  left: 30%;
  width: 400px;
}
.export_header,.export_class{
  text-align: center;
}

/*.edit_pic:hover {
  background-image: url("../assets/img/right/clazz/edit_mouseOver.png");
}
.delete_pic:hover {
  background-image: url("../assets/img/right/clazz/delete_mouseOver.png");
}
.details_pic:hover {
  background-image: url("../assets/img/right/clazz/details_mouseOver.png");
}*/
/*分页*/
#page-break {
  margin-top: 20px;
  margin-left: 30%;
}
#page-break li {
  list-style: none;
}
#page-break a {
  border: 1px solid #ddd;
  text-decoration: none;
  float: left;
  padding: 6px 12px;
  /*color: #337ab7;*/
  color: #d44950;
  cursor: pointer}
#page-break a:hover {
  background-color: #eee;
}
#page-break a .banclick {
  cursor: not-allowed;
}
#page-break .active a {
  color: #fff;
  cursor: default;
  /*background-color: #337ab7;
   border-color: #337ab7;*/
  background-color: #d44950;
  border-color: #ff6f66;
}
#page-break i {
  font-style: normal;
  color: #d44950;
  margin: 0px 4px;
  font-size: 12px;
}
#page-break .jumpbox .jumppage {
  border: 1px solid #ddd;
  margin-left: 40px;
  height: 33px;
  width: 40px;
  float: left;}
#page-break .jumpbox .jumpbtn {
  cursor: pointer;
  margin-left: 10px;
}
#page-break .jumpbox .jumpbtn:active {
  color: #d44950;
}
.dropdown-menu {
  min-width: 80px;
}
.dropdown-menu li {
  margin: 0 0 0 12%;
}
.dropdown-toggle {
  color: #d44950;
}
.exportClass{
  float: left;
  text-align: left;
  margin: 10px 0px 5px 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/researchCollection.vue